import script from "./general_masters.vue?vue&type=script&setup=true&lang=js"
export * from "./general_masters.vue?vue&type=script&setup=true&lang=js"

import "./general_masters.vue?vue&type=style&index=0&id=d888aab4&lang=scss"

const __exports__ = script;

export default __exports__